<div class="flex justify-content-center h-screen" *ngIf="isLoading">
  <div class="align-content-center">
    <p-progressSpinner
      strokeWidth="3"
      styleClass="w-6rem h-6rem"
    ></p-progressSpinner>
  </div>
</div>

<div
  class="layout-wrapper layout-static"
  [ngClass]="containerClass"
  *ngIf="!isLoading"
>
  <app-header class="layout-header"></app-header>
  <div class="layout-sidebar">
    <app-side-menu></app-side-menu>
  </div>
  <div class="layout-main-container">
    <app-base-breadcrumb class="main-breadcrumb"></app-base-breadcrumb>

    <div class="layout-main">
      <router-outlet></router-outlet>
    </div>
    <!-- <app-footer></app-footer> -->
  </div>
</div>
